import React, { FC } from 'react';
import { PresetStatusColorType } from 'antd/es/_util/colors';

import { useLang } from 'hooks';
import { Tag } from 'components/ui';
import { Override } from 'types/common';
import { TagProps } from 'types/components';
import { PaymentStatus as EPaymentStatus } from 'types/models';

const statusColors: Record<EPaymentStatus, PresetStatusColorType> = {
  [EPaymentStatus.AWAITING_3DS]: 'processing',
  [EPaymentStatus.AWAITING_AVS]: 'processing',
  [EPaymentStatus.AWAITING_CONFIRMATION]: 'processing',
  [EPaymentStatus.AWAITING_OTP]: 'processing',
  [EPaymentStatus.AWAITING_PIN]: 'processing',
  [EPaymentStatus.CREATED]: 'processing',
  [EPaymentStatus.ERROR]: 'error',
  [EPaymentStatus.PENDING]: 'processing',
  [EPaymentStatus.SUCCESS]: 'success',
};

type PaymentStatusProps = Override<Omit<TagProps, 'color' | 'children'>, {
  status: EPaymentStatus;
}>;

const PaymentStatus: FC<PaymentStatusProps> = ({ status, ...props }) => {
  const lang = useLang();

  return (
    <Tag color={statusColors[status]} {...props}>
      {lang.get(`common.paymentStatuses.${status.toLowerCase()}`)}
    </Tag>
  );
};

export default PaymentStatus;
